//Korean
export default  {
    homeScreen : {
        startConversation: '대화 시작하기',
        newConversationButton: '새로운 대화',
        newMessageButton: '+ 새로운 메시지',
        allTopics: '모든 주제',
        allChatsButton: '모두 보기',
        poweredBy: 'Powered by Richpanel',
        reOpenConversation: '대화 다시 보기',
        recentConversations: '대화 목록',
        startAChat: '채팅 시작하기',
        noRecentConversations: '최근 대화 없음',
        noRecentOrders: '최근 주문 없음',
        haveAQuestion: "문의사항이 있으신가요?",
        conversationClosed: `"이 대화는 종료되었습니다. 이 이슈에 대해 다른 문의사항이 있으시다면 대화를 다시 시작해주세요."`,
        retry: '재시도',
        errorOccured: '요청을 처리하는 동안 오류가 발생했습니다.',
        successMessage: '요청이 접수 되었으며 팀에서 곧 [email]을 통해서 연락을 드릴 것입니다.',
        loadingMessage: '기다려 주세요. 귀하의 요청을 처리하고 있습니다.',
        goHome: 'OKAY',
        sendUsMessage: '우리에게 메시지 보내기',
        endChat: '채팅 종료',
        goto: '이동',
    },

    orderStatuses: {
        'completed': 'Completed',
        'pending': 'Pending',
        'on hold': 'On hold',
        'processing': 'Processing',
        'cancelled': 'Cancelled',
        'fulfilled': 'Fulfilled',
        'confirmed': 'Confirmed',
    },

    loginScreen: {
        title: '계정에 액세스',
        titleForOrdersScreenForward: '로그인하여 주문 조회하기',
        userIdFieldTitle: "전화 또는 이메일",
        userIdFieldPlaceHolder: "전화번호 혹은 이메일 주소를 입력해주세요",
        sendCode: "시작하다",
        enterCode: '저희가 보내드린 코드를 입력하세요',
        enterTheCode: '코드를 입력하세요',
        notYourUserId: '귀하의 {userIdType}이 아니십니까?',
        userIdTypes: {
            'phone': '번호',
            'email': '이메일',
        },
        change: '변경',
        notReceivedCode: "코드를 못받으셨나요?",
        resendCode: '재전송',
        in: 'in',
        verifyCode: '인증하기',
        logout: '로그아웃',
        orderNumberFieldTitle: '주문 번호',
        orderNumberFieldPlaceholder: '주문 번호를 입력하세요. 예: 1234',
        zipcodeFieldTitle: '배송 번호',
        zipcodeFieldPlaceholder: '배송 번호를 입력하세요',
        emailFieldTitle: '이메일',
        emailFieldPlaceholder: '이메일 주소를 입력하세요',
    },

    orderList : {
        reorder: '재주문',
        getHelp: '도움이 필요하신가요?',
        startNewConversation: '+ 새 메시지',
        viewPreviousOrder:'모둔 주문 보기',
        seeAll: '모두보기',
        viewMoreOrders: '주문 더 보기',
        viewOrderStatus: '주문 상태 보기',
        chatWithUs: '저희와 채팅을 원하시나요?',
        issueWithPreviousOrder:'이전 주문 관련 도움이 필요하신가요?' ,
        orderLabel: '주문',
        help: '문의사항이 있으신가요?',
        lastOrder: '마지막 주문',
        selectRelevantItems: '관련 제품 선택하기',
        selectItemsErrorMsg: '계속하려면 항목을 선택하십시오.',
        selectAll: '모두 선택하기',
        selectQuantity: '제품 갯수?',
        helpWithThisOrder: '이 주문 관련하여 문의사항이 있으신가요?',
        yourOrders: '주문',
        view: '보기',
        track: '조회',
        addressTitle: '요약',
        billingAddressTitle: '청구지',
        shippingAddressTitle: '배송지',
        receiptTitle: '개',
        itemTotal: '총 갯수',
        taxes: '세금',
        discounts: '할인', 
        giftCard: '기프트 카드', 
        deliveryCharges: '배송비',
        total: '총',
        loginToViewOrders: '존재하는 고객?',
        loginSuggestion: "신속한 주문 관련 도움 받기",
        trackingOrderLabel: '주문 추적하기',
        shipmentDescription: "발송 상태에 대한 업데이트를 보려면 이 페이지로 돌아오십시오.",
        free: "무료",
        selectedItems: "선택된 항목",
        items: "항목",
        "orderSearchPlaceholder": 'Filter by order #',
        "noOrderFound": '일치하는 주문이 없습니다. {orderId}',
    },
    chatListScreen: {
        header: '당신의 대화',
    },
    sentences: {
        "IN_A_DAY" : "팀은 일반적으로 하루 안에 응답합니다.",
        "IN_FEW_MINUTES": "팀은 일반적으로 몇 분 안에 응답합니다.",
        "IN_FEW_HOURS": "팀은 일반적으로 몇 시간 안에 응답합니다.",
        "AS_SOON_AS_THEY_CAN": "팀이 가능한 빨리 연락 드릴 것입니다.",
        "BACK_ON": "다시 시작하세요.",
        "BACK_IN": "다시 들어오세요.",
        "HOURS": "시간",
        "MINUTES": '분',
        provideBelowDetails: "아래 세부 정보를 알려주세요",
    },
    inputFields: {
        submitted: '제출되었습니다.'
    },
    inputPropDisplayNames: {
        "email": "이메일",
        "phone": "연락처",
        "Phone": "Phone",
        "firstName": "이름",
        "lastName": "성",
        "uid": "아이디",
        "campaign": "UTM 캠페인",
        "medium": "UTM 매체",
        "googleplus": "구글 플러스",
        "shippingPhone": "연락처",
        "source": "UTM 소스",
        "lastOrderAt": "마지막 주문 시간",
        "firstOrderAt": "첫 주문 시간",
        "visits": "세션",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "마지막 접속시간",
        "createdAt": "첫 접속시간",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "청구서 이메일",
        "billingPhone": "청구 연락처",
        "shippingEmail": "배송 이메일",
        "state": "주",
        "city": "도시",
        "country": "나라",
        "deviceType": "기기 종류",
        "browserName": "브라우저 이름",
        "osName": "OS 이름",
        "platform": "플랫폼",
        "ltv": "CLV",
        "ordersCount": "주문 수",
        "name": "이름",
        "RichpanelPredictedCLV": "예상 CLV",
        "RichpanelAliveProbability": "주문 가능성",
        "RichpanelNextOrderDate": "다음 주문 잘짜",
        "RichpanelPredictedOrderCount": "예상 주문 수",
        "aov": "AOV",
        "WebsiteURL":"웹싸이트 URL"
    },
    botMessages: {
        EXISITING_CUSTOMER: '기존 고객이신가요?',
        YES_EXISITING_CUSTOMER: "네, 기존 고객입니다.",
        NO_EXISITING_CUSTOMER: "아니요. 아직 고객이 아닙니다.",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "어떻게 연락 드릴까요?",
        YOU_WILL_BE_NOTIFIED_EMAIL: "연락이 오면 여기와 이메일({email})로 알림이 표시됩니다.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "연락이 오면 여기에 알림이 표시됩니다.",
        LEAVE_YOUR_MESSAGE: "메시지를 남겨주세요.",
        TEAM_WILL_BE_BACK_IN:"팀은 {hours} 시간 안에 연락 드릴 것입니다",
        TEAM_WILL_BE_BACK_ON:"팀은 {availableAt}에 돌아올 것입니다.",
        FEW_MORE_DETAILS: "감사합니다! 몇 가지 세부 사항을 더 알려주세요. 저희가 적합한 담당직원을 연결해 드리겠습니다.",
    },
    initialForm: {
        heading: '채팅을 시작하기 위해 세부사항을 입력해주세요',
        startChat: '채팅 시작하기'
    },
    customerJourneyPreChatForm: {
        heading: '채팅 시작하기',
        startChat: '채팅 시작하기',
        proceed: '진행하기',
        canWeHelpWithAnythingElse: '도움이 필요하신가요?',
        yes: 'Yes',
        no: 'No',
        noThanks: "감사합니다.",
        yesContactSupport: "고객센터팀과 채팅하기",
        contactSupport: "고객센터팀에 연락하기",
    },
    rating: {
        askedHeader: '대화 평가하기',
        successHeader: '귀하는 이 대화를 평가하였습니다.',
        thanksMessage: "알려주셔서 감사합니다.",
        placeholderForRatingFeedback: ""
    },
    placeholders: {
        emojiSearch: '이모티콘 검색',
        typeAMessage: '메시지 입력',
        searchGifs: 'GIF 검색',
    },
    lastMessageText: {
        sentAGif: 'GIF를 보냈습니다',
        sharedFile: '파일 공유',
        askedForQualificationDetails: '자격 세부 정보를 요청했습니다.',
        askedForRating: '평점을 요청하였습니다.',
        askedForFeedback: '피드백을 요청하였습니다.',
        sharedOrderSummary: "주문 요약을 공유하였습니다."
    },
    greetingAnimation: {
        weAreOnline: '온라인입니다.',
        askUsAnything: '무엇이든 물어보세요',
        chatWithUs: '채팅하기'
    },
    errorMessages: {
        enterEmailOrPhone:  "이메일 / 전화 번호를 입력하세요",
        enterValidOrPhone: "유효한 이메일 / 전화 번호를 입력하세요.",
        userNotFound: "이 전화 / 이메일로 계정을 찾을 수 없습니다.",
        enterCode: '로그인 코드를 입력하십시오',
        invalidCode: '유효하지 않은 코드'
    }
}